import { Observable, of } from 'rxjs'
import { map, switchMap, take } from 'rxjs/operators'

import { AuditCampaign, AuditCampaignFeatured, getTranslatedString } from '@skinsoft/types'
import { auditCampaignSelectors, thesaurusTermSelectors } from '@skinsoft/selectors'
import { DATE_FORMATS, getReadableDate, toFormat } from '@skinsoft/utils'
import { ThesaurusTermDataStore } from '@skinsoft/entity'

export function toCampaignFeatured$(campaign: AuditCampaign, locale: string): Observable<AuditCampaignFeatured> {

    const featuredCampaign: AuditCampaignFeatured = {
        auditType: auditCampaignSelectors.auditType(campaign),
        auditors: auditCampaignSelectors.auditors(campaign),
        campaignCreationDate: getReadableDate(
            toFormat(
                auditCampaignSelectors.campaignCreationDate(campaign),
                DATE_FORMATS.DD_MM_YYYY_SLASH_HMS,
            ),
        ),
        campaignManager: auditCampaignSelectors.campaignManager(campaign),
        id: auditCampaignSelectors.id(campaign),
        identificationNumber: auditCampaignSelectors.identificationNumber(campaign),
        title: auditCampaignSelectors.title(campaign, locale)
    }

    return of(featuredCampaign).pipe(
        // Resolving audit type
        switchMap(
            (theFeaturedCampaign) => {
                if (theFeaturedCampaign.auditType) {

                    return ThesaurusTermDataStore.getInstance().fetchOne(featuredCampaign.auditType)
                        .pipe(
                            take(1),
                            map(
                                term => {
                                    if(term) {
                                        try {
                                            const auditType = getTranslatedString(thesaurusTermSelectors.preferredTerm(term), locale)
                                            return {
                                                ...theFeaturedCampaign,
                                                auditType: auditType
                                            }
                                        } catch(err) {
                                            
                                        }
                                    }
                                    return theFeaturedCampaign
                                }
                            )
                        )
                }
                else {
                    return of(theFeaturedCampaign)
                }
            }
        )
    );
}